export type AdminModule =
  | "members"
  | "products"
  | "orders"
  | "quotes"
  | "notices"
  | "inquiries";

export type AdminRow = Record<string, string> & { id: string };

export interface ModuleConfig {
  id: AdminModule;
  title: string;
  searchTitle: string;
  listTitle: string;
  columns: Array<{ key: string; label: string; align?: "center" | "right" }>;
  searchFields: Array<{ key: string; label: string; placeholder: string; type?: "select"; options?: string[] }>;
  rows: AdminRow[];
}

export const adminModules: ModuleConfig[] = [
  {
    id: "members",
    title: "회원 정보 관리",
    searchTitle: "회원 검색",
    listTitle: "회원 리스트",
    searchFields: [
      { key: "code", label: "회원 코드", placeholder: "ex. USER-260101A05" },
      { key: "name", label: "회원명", placeholder: "ex. 홍길동" },
      { key: "phone", label: "연락처", placeholder: "ex. 01012341234" },
      { key: "email", label: "이메일", placeholder: "ex. abcd15@naver.com" },
      { key: "status", label: "회원 상태", placeholder: "전체", type: "select", options: ["전체", "정상", "정지"] },
    ],
    columns: [
      { key: "no", label: "No", align: "center" },
      { key: "code", label: "회원 코드" },
      { key: "name", label: "회원명" },
      { key: "loginId", label: "회원 ID" },
      { key: "email", label: "이메일" },
      { key: "phone", label: "휴대폰 번호" },
      { key: "gender", label: "성별", align: "center" },
      { key: "status", label: "상태", align: "center" },
    ],
    rows: [
      { id: "m5", no: "05", code: "USER-260101A05", name: "박지민", loginId: "aurora01", email: "abcd15@naver.com", phone: "010-1234-5678", gender: "남", status: "정상" },
      { id: "m4", no: "04", code: "USER-260101A04", name: "이서준", loginId: "nextworks", email: "abcd15@naver.com", phone: "010-1234-1234", gender: "여", status: "정지" },
      { id: "m3", no: "03", code: "USER-260101A03", name: "최유진", loginId: "daeon03", email: "abcd15@naver.com", phone: "010-1234-1234", gender: "여", status: "정상" },
      { id: "m2", no: "02", code: "USER-260101A02", name: "한도윤", loginId: "evergreen", email: "abcd15@naver.com", phone: "010-1234-1234", gender: "남", status: "정상" },
      { id: "m1", no: "01", code: "USER-260101A01", name: "김하은", loginId: "monodesign", email: "abcd15@naver.com", phone: "010-1234-1234", gender: "여", status: "정상" },
    ],
  },
  {
    id: "products",
    title: "상품 관리",
    searchTitle: "검색",
    listTitle: "상품 리스트",
    searchFields: [
      { key: "code", label: "상품번호", placeholder: "ex. PROD-260805A05" },
      { key: "name", label: "상품명", placeholder: "상품명을 입력해 주세요." },
      { key: "category", label: "카테고리", placeholder: "전체", type: "select", options: ["전체", "약과", "유과/산자", "강정/엿강정", "정과/다식", "전병/오란다", "선물세트", "답례품", "기타"] },
      { key: "status", label: "판매상태", placeholder: "전체", type: "select", options: ["전체", "판매중", "판매중지"] },
    ],
    columns: [
      { key: "no", label: "No", align: "center" }, { key: "code", label: "상품번호" }, { key: "name", label: "상품명" },
      { key: "status", label: "판매상태", align: "center" }, { key: "category", label: "카테고리" },
      { key: "price", label: "정가(원)", align: "right" }, { key: "salePrice", label: "판매가(원)", align: "right" }, { key: "createdAt", label: "등록일시" },
    ],
    rows: Array.from({ length: 5 }, (_, index) => ({
      id: `p${5 - index}`, no: `0${5 - index}`, code: `PROD-260805A0${5 - index}`, name: "소담원 전통 한과 선물세트", status: index === 1 ? "판매중지" : "판매중", category: ["선물세트", "약과", "유과/산자", "강정/엿강정", "정과/다식"][index], price: "100,000", salePrice: "99,000", createdAt: "2026.08.05 10:30",
    })),
  },
  {
    id: "orders",
    title: "결제/배송 관리",
    searchTitle: "검색",
    listTitle: "주문 목록",
    searchFields: [
      { key: "orderNo", label: "주문번호", placeholder: "ex. ORED-260805A05" }, { key: "member", label: "회원명", placeholder: "회원명을 입력해 주세요." },
      { key: "status", label: "처리상태", placeholder: "전체", type: "select", options: ["전체", "주문완료", "주문확인", "배송중", "배송완료", "확정", "주문취소"] },
    ],
    columns: [
      { key: "no", label: "No", align: "center" }, { key: "orderNo", label: "주문 번호" }, { key: "product", label: "상품명" },
      { key: "qty", label: "수량", align: "center" }, { key: "member", label: "주문회원" }, { key: "phone", label: "연락처" }, { key: "address", label: "주소" },
      { key: "status", label: "주문 상태", align: "center" }, { key: "amount", label: "결제 금액", align: "right" }, { key: "method", label: "결제 수단", align: "center" },
    ],
    rows: ["주문완료", "주문확인", "배송중", "확정", "주문취소"].map((status, index) => ({
      id: `o${5 - index}`, no: `0${5 - index}`, orderNo: `ORED-260805A0${5 - index}`, product: "소담원 한과 선물세트", qty: String(index % 3 + 1), member: ["박지민", "이서준", "최유진", "한도윤", "김하은"][index], phone: "010-1234-5678", address: "서울시 성동구 성수이로 88", status, amount: ["98,000원", "89,000원", "72,000원", "60,000원", "48,000원"][index], method: "카드결제",
    })),
  },
  {
    id: "quotes",
    title: "견적 관리",
    searchTitle: "검색",
    listTitle: "견적요청 목록",
    searchFields: [
      { key: "quoteNo", label: "견적코드", placeholder: "ex. ESTI-260805A05" }, { key: "product", label: "제품명", placeholder: "제품명을 입력해 주세요." },
      { key: "purpose", label: "용도", placeholder: "전체", type: "select", options: ["전체", "답례품", "명절", "행사", "기타"] },
      { key: "status", label: "견적상태", placeholder: "전체", type: "select", options: ["전체", "견적요청", "상담중", "견적등록"] },
    ],
    columns: [
      { key: "no", label: "No", align: "center" }, { key: "quoteNo", label: "견적코드" }, { key: "product", label: "제품명" },
      { key: "status", label: "견적상태", align: "center" }, { key: "member", label: "회원명" }, { key: "phone", label: "연락처" },
      { key: "purpose", label: "용도" }, { key: "due", label: "납기" }, { key: "createdAt", label: "등록일시" },
    ],
    rows: ["견적요청", "상담중", "견적요청", "견적등록", "견적등록"].map((status, index) => ({
      id: `q${5 - index}`, no: `0${5 - index}`, quoteNo: `ESTI-260805A0${5 - index}`, product: "맞춤 한과 답례품", status, member: "홍길동", phone: "010-1234-1234", purpose: index % 2 ? "명절" : "답례품", due: "2026.09.10까지", createdAt: "2026.08.05 10:30",
    })),
  },
  {
    id: "notices",
    title: "공지사항 관리",
    searchTitle: "공지사항 검색",
    listTitle: "공지사항 목록",
    searchFields: [
      { key: "noticeNo", label: "공지번호", placeholder: "ex. BORD-260805A05" }, { key: "title", label: "제목", placeholder: "ex. 런칭 공지" }, { key: "status", label: "게시 상태", placeholder: "전체", type: "select", options: ["전체", "게시중", "게시종료"] },
    ],
    columns: [
      { key: "no", label: "No", align: "center" }, { key: "noticeNo", label: "공지번호" }, { key: "title", label: "제목" },
      { key: "status", label: "게시 상태", align: "center" }, { key: "period", label: "게시 기간" },
    ],
    rows: Array.from({ length: 5 }, (_, index) => ({ id: `n${5 - index}`, no: `0${5 - index}`, noticeNo: `BORD-260805A0${5 - index}`, title: "2026년 추석 연휴 배송 일정 안내", order: "-", status: "게시중", period: "2026.08.25 ~ 2026.09.18" })),
  },
  {
    id: "inquiries",
    title: "문의 관리",
    searchTitle: "문의 검색",
    listTitle: "문의 목록",
    searchFields: [
      { key: "inquiryNo", label: "문의번호", placeholder: "ex. REQS-260805A01" }, { key: "title", label: "제목", placeholder: "ex. 제휴" }, { key: "status", label: "답변 상태", placeholder: "전체", type: "select", options: ["전체", "답변대기", "답변완료"] },
    ],
    columns: [
      { key: "no", label: "No", align: "center" }, { key: "inquiryNo", label: "문의번호" }, { key: "title", label: "제목" },
      { key: "type", label: "문의유형" }, { key: "member", label: "회원명" }, { key: "phone", label: "연락처" }, { key: "status", label: "답변 상태", align: "center" },
    ],
    rows: Array.from({ length: 5 }, (_, index) => ({ id: `i${5 - index}`, no: `0${5 - index}`, inquiryNo: `REQS-260805A0${5 - index}`, title: "배송지 변경이 가능한가요?", type: "배송 문의", member: "qwer1234", phone: "010-1234-1234", status: index < 2 ? "답변대기" : "답변완료" })),
  },
];

export const orderHistory = adminModules.find((module) => module.id === "orders")!.rows;
